/** eslint-ignore */
export const CONSUMER_DEFAULT_VALUES = {
    FirstName: '',
    LastName: '',
    gender: 'M',
    Address: {
        Address: '',
        City: '',
        State: '',
        Zipcode: '',
        Country: 'US'
    }, // You can expand this for AddressInput handling
    OccupencyType: 'PRIMARY',
    isOwnProperty: false,
    isOnRent: false,
    isIdAddressCurrentResidence: false
};

export const REALTOR_DEFAULT_VALUE = {
    FirstName: '',
    LastName: '',
    bio: '',
    website: '',
    Statelicenses: [],
    collateral: {
        biotext: ''
    },
    Address: {
        Address: '',
        City: '',
        State: '',
        Zipcode: '',
        Country: 'US'
    } // You can expand this for AddressInput handling
};
